<template>
	<div class="">
		<div class="flex">
			<div class="" style="margin: 5px 0;">
				<div class="flex alit">
					<div class="shuxian"></div>
					<div class="yj-title">感知预警</div>
				</div>
				<div class="flex alit">
					<left-top-vue class="lefttop"></left-top-vue>
					<div class="ycfb">异常状态分布:26%</div>
				</div>
			</div>


			<div class="">
				<div class="flex alit" style="margin: 5px 0;">
					<div class="shuxian"></div>
					<div class="yj-title">监督评价</div>
				</div>
				<div class="flex alit" style="margin-top: 5px;">
					<div class="flex alit" style="margin: 0 40px 0 10px;">
						<div class="flexCol justb jdpjl">
							<div class=""></div>
							<div class="jsl" style="height: 92.6%;"></div>
						</div>
						<div class="">
							<div class="jsl-num">92.6 %</div>
							<div class="jsl-title">处理及时率</div>
						</div>
					</div>
					<div class="flex alit" style="margin-left: 10px;">
						<div class="flexCol justb jdpjl">
							<div class=""></div>
							<div class="jsl" style="height: 80%;"></div>
						</div>
						<div class="">
							<div class="jsl-num">80 %</div>
							<div class="jsl-title">行业基准线</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="">
			<div class="flex alit" style="margin: 5px 0;">
				<div class="shuxian"></div>
				<div class="yj-title">决策处置</div>
			</div>
			<div class="flex alit justb" style="width: 100%;">
				<div class="flex justb" style="width: 100%;">
					<div class="flexCol alit">
						<div class="jccl flexCol alit">
							<div class="text1">12件</div>
							<!-- <div class="text2"></div> -->
							<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A2%84%E8%AD%A6%E5%86%B3%E7%AD%96/%E5%BE%85%E5%A4%84%E7%90%86%402x.png"
								alt="" />
						</div>
						<div class="status">待处理</div>
					</div>
					<div class="flexCol alit">
						<div class="jccl flexCol alit">
							<div class="text1">2件</div>
							<!-- <div class="text2"></div> -->
							<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A2%84%E8%AD%A6%E5%86%B3%E7%AD%96/%E5%A4%84%E7%90%86%E4%B8%AD%402x.png"
								alt="" />
						</div>
						<div class="status">处理中</div>
					</div>
					<div class="flexCol alit">
						<div class="jccl flexCol alit">
							<div class="text1">129 件</div>
							<!-- <div class="text2"></div> -->
							<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A2%84%E8%AD%A6%E5%86%B3%E7%AD%96/%E5%B7%B2%E5%8A%9E%E7%BB%93%402x.png"
								alt="" />
						</div>
						<div class="status">已办结</div>
					</div>
				</div>
			</div>
		</div>
		<div class="" style="margin-bottom: 0px;">
			<div class="flex alit" style="margin: 5px 0;">
				<div class="shuxian"></div>
				<div class="yj-title">复盘评估</div>
			</div>
			<div class="fptable">
				<table style="flex: 1;">
					<thead>
						<tr style="background-color: rgba(69, 108, 239, 0.3);text-align: center;color: #fff;">
							<td>托单号</td>
							<td>异常类型</td>
						</tr>
					</thead>
					<tbody>
						<tr class="zxlist" style="color: #fff;text-align: center;">
							<td style="width: 50%;padding: 6px 0;">NSH12219281791727</td>
							<td>爆舱落配</td>
						</tr>
						<tr class="zxlist" style="color: #fff;text-align: center;">
							<td style="width: 50%;padding: 6px 0;">NSH12219281791884</td>
							<td>冷藏中断</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<!-- <div class="">
			<div class="td">
				<div class="tdpy flex justb">
					<div class=""></div>
					<div class="">工作举措</div>
					<div class="">203050</div>
				</div>
				<div class="tdbg"></div>
			</div>
			<div class="flex alit">
				<div class="gzjc-left">20个重点发展区县</div>
			</div>
			<div class="flex alit">
				<div class="gzjc-left">20个重点发展区县</div>
			</div>
			<div class="flex alit">
				<div class="gzjc-left">20个重点发展区县</div>
			</div>
			<div class="flex alit">
				<div class="gzjc-left">20个重点发展区县</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	import leftTopVue from './yjjc/leftTop.vue';
	export default {
		components: {
			leftTopVue
		},
		data() {
			return {

			}
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style scoped lang="scss">
	.gzjc-left {
		width: 120px;
		height: 30px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 10px;
		color: #FFFFFF;
		line-height: 30px;
		text-align: center;
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A2%84%E8%AD%A6%E5%86%B3%E7%AD%96/%E5%B7%A5%E4%BD%9C%E4%B8%BE%E6%8E%AA%E5%B7%A6%402x.png');
		background-size: 100% 100%;
	}

	.td {
		position: relative;
		margin-top: 5px;

		.tdpy {
			font-weight: normal;
			font-size: 12px;
			color: #E6EDF8;
			margin-top: -8px;
			position: absolute;
			font-style: italic;
			width: 100%;
		}

		.tdbg {
			width: 100%;
			height: 18px;
			background: linear-gradient(90deg, #3A61BB 0%, #29439D 100%);
			border-radius: 0px 0px 0px 0px;
		}
	}

	.fptable {
		border: 1px solid;
		border-image: linear-gradient(270deg, rgba(1, 194, 255, 1), rgba(1, 194, 255, 0)) 1 1;
	}

	.jsl-title {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 11px;
		color: #B5C5D4;
		margin-top: 5px;
	}

	.jsl-num {
		font-weight: 900;
		font-size: 14px;
		color: #EDFBFF;
		font-style: italic;
		background: linear-gradient(180deg, #FFF600 21%, #FFFCA2 83%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.jdpjl {
		width: 10px;
		height: 56px;
		background: rgba(255, 255, 255, 0.2);
		border-radius: 10px;
		margin-right: 5px;

		.jsl {
			width: 10px;
			background: linear-gradient(180deg, #FFFFFF 15%, #F7FF57 81%), #F6F9FE;
			border-radius: 10px 10px 10px 10px;
		}
	}

	.status {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 11px;
		color: #B5C5D4;
	}

	.jccl {
		.text1 {
			font-family: DIN-BoldItalic, DIN-BoldItalic;
			font-weight: 900;
			font-size: 16px;
			background: linear-gradient(180deg, #FFF600 0%, #ffffff 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			font-style: italic;
			padding-right: 2px;
			margin-bottom: 15px;
		}

		.text2 {
			font-weight: 500;
			font-size: 11px;
			color: #FFFFFF;
		}

		img {
			width: 100px;
			height: 30px;
			margin-top: -15px;
		}
	}

	.ycfb {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 11px;
		color: #B5C5D4;
		width: 77px;
	}

	.lefttop {
		width: 64px;
		height: 64px;
	}

	.yj-title {
		font-family: JiangChengXieHei, JiangChengXieHei;
		font-size: 12px;
		color: #FFFFFF;
		font-style: italic;
		margin-left: 5px;
	}

	.shuxian {
		width: 12px;
		height: 5px;
		background: #9BC74B;
		border-radius: 0px 0px 0px 0px;
	}
</style>